import React from 'react';

import HyperLink from '../../../shared/components/hyperlink'
import AdaptiveImage from '../../../shared/components/adaptive-image'
import Link from '../../../ui/components/link';

import './css/article-feature-cell.less';


const ArticleFeatureCell = (props) => {

  let { slug, featureDate, featureTitle, featureThumbnail:image} = props;


  let d = new Date(featureDate);
  const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

  let date = monthNames[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();

  if(typeof image === "string") {
    image = {
      src: image,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }
  else if(Array.isArray(image)) {
    image = {
      src: image[0],
      alt: 'HPImage',
      title: 'HPImage',
    }
  }
  else if(!image) {
    image = {
      src: null,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }
  
  let readMoreButton = <Link className="blog-read-more" to={`/${slug}`} type="link">READ MORE</Link>;
	
  return (
      <div className="article-feature-cell">

          <div className="article-feature-content">
            <HyperLink to={`/${slug}`}>
              <h2 className="blog-feature-header">{featureTitle}</h2>
              <p className="blog-cell-date">{date}</p>
              { readMoreButton }
            </HyperLink>
          </div>
          <div className="article-feature-thumbnail">
            <HyperLink to={`/${slug}`}>
            <p className="featured-text">Featured</p>
            <AdaptiveImage
                className="blog-cell-thumbnail-image"
                src={image.src}
                alt={image.alt}
								title={image.title}
								lazyload={true}
            />
              <div className="article-feature-content-mobile">
              <p className="blog-cell-title">{featureTitle}</p>
              <div style={{textAlign: "left"}}>
                <div className="blog-cell-date">{date}</div>
                { readMoreButton }
              </div>
              </div>
            </HyperLink>
          </div>
      </div>
  );
}

export default React.memo(ArticleFeatureCell);
